/**
 * QueryReveal — the plain-language description of the chart being built. SQL stays on the backend
 * for audit logging and is never sent to or rendered by the chat UI.
 */
import React from 'react';
import { useReducedMotion } from 'framer-motion';
import { tokens } from './tokens';

export function QueryReveal({ queryText, lead = false }: { queryText: string; lead?: boolean }) {
  const reduceMotion = useReducedMotion() ?? false;

  return (
    <div style={{ marginBottom: 10 }}>
      {queryText && (
        <span
          style={{
            fontSize: lead ? 15 : 13,
            fontWeight: 600,
            color: lead ? tokens.text.primary : tokens.text.secondary,
            lineHeight: 1.5,
            transition: reduceMotion ? undefined : 'font-size 200ms ease, color 200ms ease',
          }}
        >
          {queryText}
        </span>
      )}
    </div>
  );
}
